@if (grade == 0) {
  <div class="research-grade research-grade-none" ngbPopover="{{'data.shared.research_grade.tooltips.level0' | translate}}" triggers="hover" container="body">
    <fa-icon [icon]="faStarEmpty"></fa-icon>
    <fa-icon [icon]="faStarEmpty"></fa-icon>
    <fa-icon [icon]="faStarEmpty"></fa-icon>
  </div>
}

@if (grade == 1) {
  <div class="research-grade" ngbPopover="{{'data.shared.research_grade.tooltips.level1' | translate}}" triggers="hover" container="body">
    <fa-icon [icon]="faStarFull"></fa-icon>
    <fa-icon [icon]="faStarEmpty"></fa-icon>
    <fa-icon [icon]="faStarEmpty"></fa-icon>
  </div>
}

@if (grade == 2) {
  <div class="research-grade" ngbPopover="{{'data.shared.research_grade.tooltips.level2' | translate}}" triggers="hover" container="body">
    <fa-icon [icon]="faStarFull"></fa-icon>
    <fa-icon [icon]="faStarFull"></fa-icon>
    <fa-icon [icon]="faStarEmpty"></fa-icon>
  </div>
}

@if (grade == 3) {
  <div class="research-grade" ngbPopover="{{'data.shared.research_grade.tooltips.level3' | translate}}" triggers="hover" container="body">
    <fa-icon [icon]="faStarFull"></fa-icon>
    <fa-icon [icon]="faStarFull"></fa-icon>
    <fa-icon [icon]="faStarFull"></fa-icon>
  </div>
}